<section class="hero-section">

    <div class="hero-bg-circle circle-1"></div>
    <div class="hero-bg-circle circle-2"></div>

    <div class="container">

        <div class="row  justify-content-center">

            <div class="col-xl-10 text-center">

                <!-- Offer -->
                <div class="offer-pill">
                    🔥 {{ 'heroSection.offerTitle' | translate }}
                </div>

                <!-- Heading -->
                <h1 class="hero-title">
                    {{ 'heroSection.title' | translate | uppercase }}
                </h1>

                <p class="hero-subtitle">
                    {{ 'heroSection.subtitle' | translate }}
                </p>

                <!-- Feature Chips -->
                <div class="feature-chips">

                    <span class="feature-chip">
                        <i class="fas fa-location-dot"></i>
                        {{ 'heroSection.multiLocation' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fas fa-users"></i>
                        {{ 'heroSection.teamScheduling' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fab fa-whatsapp"></i>
                        {{ 'heroSection.whatsappReminders' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fas fa-credit-card"></i>
                        {{ 'heroSection.onlinePayments' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fas fa-check-circle"></i>
                        {{ 'heroSection.appointmentApproval' | translate }}
                    </span>

                    <span class="feature-chip">
                        <i class="fas fa-user-clock"></i>
                        {{ 'heroSection.noShowTracking' | translate }}
                    </span>

                </div>
                <!-- Buttons -->
                <div class="hero-actions">

                    <a [routerLink]="'/about-us'" class="btn btn-light hero-btn">
                        {{ 'heroSection.about' | translate }}
                    </a>
                    <!-- {{isLoggedIn}} -->
                    @if (isLoggedIn) {
                    <a [routerLink]="'/app'" class="btn btn-primary hero-btn">
                        {{ 'heroSection.getStarted' | translate }}
                    </a>
                    }

                    @if (!isLoggedIn) {
                    <a [routerLink]="'/auth/login'" class="btn btn-primary hero-btn">
                        {{ 'heroSection.login' | translate }}
                    </a>
                    }

                    @if (!isLoggedIn) {
                    <a href="https://clockflex.clfx.in/app/book-appointment/loc/1f63f398-3586-4964-d735-08de574647e3/bt/b588e79b-20d8-4cb8-e478-08de574774b8"
                        target="_blank" class="btn btn-warning hero-btn">
                        {{ 'heroSection.bookDemo' | translate }}
                    </a>
                    }

                </div>
            </div>
        </div>
    </div>
</section>